var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconBasket = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M8.35725 4.86378L5.4255 9.75003H5.01525C5.00625 9.75003 4.9965 9.75003 4.9875 9.75003H3C2.586 9.75003 2.25 10.086 2.25 10.5C2.25 10.914 2.586 11.25 3 11.25H4.37325L6.012 20.3828C6.0765 20.7405 6.387 21 6.75 21H17.25C17.613 21 17.9242 20.7398 17.988 20.3828L19.6268 11.25H21C21.414 11.25 21.75 10.914 21.75 10.5C21.75 10.086 21.414 9.75003 21 9.75003H19.0125C19.0035 9.75003 18.9937 9.75003 18.9847 9.75003H18.5745L15.6427 4.86378C15.4298 4.50828 14.9693 4.39353 14.6138 4.60653C14.2583 4.81953 14.1435 5.28003 14.3565 5.63553L16.8248 9.75003H7.17375L9.642 5.63553C9.855 5.28003 9.74025 4.81953 9.38475 4.60653C9.02925 4.39353 8.56875 4.50828 8.35575 4.86378H8.35725ZM18.1035 11.25L16.623 19.5H7.37775L5.89725 11.25H18.1035Z", fill: "black" }))),
        alt: 'Basket',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconBasket;
//# sourceMappingURL=index.js.map